import { schema } from 'normalizr';

const FeatureSchema = new schema.Entity('features', {}, { idAttribute: 'key' });
const FeatureAssociationSchema = new schema.Entity(
  'featureAssociations',
  {
    feature: FeatureSchema,
  },
  { idAttribute: 'id' },
);

export { FeatureSchema, FeatureAssociationSchema };

export default FeatureSchema;
